import React, {
  FunctionComponent as FC,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux'; // To call Action Creators
import { State } from '../../../../../state';
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../../state";
import * as d3 from 'd3';
import _ from 'lodash';
import './index.scss';

import { forceSimulation, forceX, forceY, forceCollide } from 'd3-force';

import { MainViewTypes, ImpactViewTypes } from '../../../../../types/data.d';
import { GrantGlyphType, CitationFlowType, ImpactType, grantFieldCode2Name } from '../../../../../types/data.global';

import PredictionGlyph from './../GrantGlyph/PredictionGlyph';
import ImpactCountGlyph from './../GrantGlyph/ImpactCountGlyph';
import RCIGlyph from './../GrantGlyph/RCIGlyph';

// // [abandon] method 1: import from `style.global.ts`
// import { glyphStyle } from '../../../../../types/style.global';
// method 2: import from uiReducer > glyphStyle, see code below in the component


// // temp, hard code, to update in style.global.ts
// const glyphStyle = {
//   svgR: svgSize.mainview.height / 2,
//   grantGlyphGroupR: 180, // grant type node整个大小
//   glyphMaxR: 60, // temp, unified glyph size. TODO: scale the group with total_impact
//   nodePadding: 5,
//   glyphRRangeRatio: { min: 0.4, max: 1 },
//   minR_Ratio: { directImpact: 0.2, indirectImpact: 0.5, },
//   RDifference_Ratio: { directImpact: 0.3, indirectImpact: 0.5, },  // value范围在[minR_Ratio, minR_Ratio + RDifference_Ratio]之间
//   collideStrength: 1,
// }



interface GlyphGroupProps {
  glyphData: any[];
  entityFieldGraphData: any;
  predictionData: MainViewTypes.PredictionResult;
  circleData: any[];
}

const GlyphGroup: FC<GlyphGroupProps> = (props) => {

  const {
    glyphData,
    entityFieldGraphData,
    predictionData,
    circleData
  } = props;

  // console.log('circleData: ', circleData)
  // console.log('circleData[0].grant_field_code: ', circleData[0].grant_field_code, typeof circleData[0].grant_field_code)


  const dispatch = useDispatch()
  const {
    isShowWordle,
    updateWordlePosition,
    updateWordleEntity,

    updateGrantFieldNodePosition,
    onClickGrantFieldNode,
    updateHighlghtedGrantFieldID,
    onClickImpactFieldNode,
    isShowLeafNode,

    isShowHistoricalFlow,
    isShowPredictionFlow,
  } = bindActionCreators(actionCreators, dispatch)


  // console.log('\n\n\n=========== [Step 2.1] GrantTypeNode component (draw after EntityTypeLevelGraph) =============')
  // console.log('glyphData: ', glyphData)
  // console.log('predictionData: ', predictionData)

  // data reducer
  const predictionSearchResult: MainViewTypes.PredictionSearchResult = useSelector((state: State) => state.dataReducer?.predictionSearchResult) as MainViewTypes.PredictionSearchResult
  // const updatedEntityFieldDataRaw: any[] = useSelector((state: State) => state.dataReducer?.entityFieldGraph_InputData) as any[]


  // ui reducer
  const isShowHistoricalGraph = useSelector((state: State) => state.uiReducer?.isShowHistoricalGraph) as boolean;
  const isShowPredictionGraph = useSelector((state: State) => state.uiReducer?.isShowPredictionGraph) as boolean;
  const highlghtedGrantFieldID: string = useSelector((state: State) => state.uiReducer?.highlghtedGrantFieldID) as string
  // const highlghtedGrantFieldNode: MainViewTypes.HighlightedGrantFieldNode = useSelector((state: State) => state.dataReducer?.highlghtedGrantFieldNode) as MainViewTypes.HighlightedGrantFieldNode
  const glyphStyle: MainViewTypes.GlyphStyle = useSelector((state: State) => state.uiReducer?.glyphStyle) as MainViewTypes.GlyphStyle
  // const isEntityTypeGraphFinished: boolean = useSelector((state: State) => state.dataReducer?.isEntityTypeGraphFinished) as boolean
  // const impactEntitySearchResult: ImpactViewTypes.ImapctEntitySearchResult = useSelector((state: State) => state.dataReducer?.impactEntitySearchResult) as ImpactViewTypes.ImapctEntitySearchResult
  const impactType: string = useSelector((state: State) => state.uiReducer?.impactType) as string
  const citationFlowType: string = useSelector((state: State) => state.uiReducer?.citationFlowType) as string
  // const impactStatisticsTypeList: string[] = useSelector((state: State) => state.uiReducer?.impactStatisticsTypeList) as string[]
  // const topKNodes: number = useSelector((state: State) => state.uiReducer?.topKField) as number
  const glyphType: string = useSelector((state: State) => state.uiReducer?.grantGlyphType) as string
  const highlightedImpactFieldNode: MainViewTypes.HighlightedImpactFieldNode = useSelector((state: State) => state.dataReducer?.highlightedImpactFieldNode) as MainViewTypes.HighlightedImpactFieldNode


  // console.log('highlghtedGrantFieldID: ', highlghtedGrantFieldID)
  // console.log('highlightedImpactFieldNode: ', highlightedImpactFieldNode)
  // console.log('isShowHistoricalFlow: ', isShowHistoricalFlow)
  // console.log('isShowPredictionFlow: ', isShowPredictionFlow)





  // ////////////////////   Prediction Result  /////////////////////
  // // input
  // // 1. UI parameters
  // console.log('citationFlowType: ', citationFlowType)
  // console.log('impactTypeRefined: ', impactTypeRefined)
  // // // 2. temp, hard code, to replace with backend prediction result
  // // const predictionResult: MainViewTypes.PredictionResult = predictionResultTest[impactTypeRefined]
  // // // 3. temp, hard code, to replace with Xiaoyu右下角view的搜索结果
  // // const predictionSearchResult = {
  // //   // impactType: ImpactType.INDIRECT_IMPACT_FOLDED, --> already store in state `impactType`
  // //   entity: 'clinical_trial',
  // //   fieldIDList: ['C11.768', 'C23.888'],
  // // }
  // console.log('predictionSearchResult: ', predictionSearchResult)

  // filter prediction result
  // opt 1: use topK fieldIDs
  let predictionResult_SearchTerm: any[] = []
  if ((predictionSearchResult.entity === '') || (predictionSearchResult.fieldIDList.length === 0)) {
    // pass
  } else {
    if (citationFlowType === CitationFlowType.PREDICTION) {
      // console.log('predictionData: ', predictionData)
      // console.log('predictionSearchResult.entity', predictionSearchResult.entity)
      // console.log('predictionSearchResult', predictionSearchResult)
      const parts = impactType.split("_")
      const impactTypeRefined = parts.slice(0, 2).join("_")

      if (predictionData[impactTypeRefined] && predictionData[impactTypeRefined][predictionSearchResult.entity]) {
        // console.log('found!!')
        predictionResult_SearchTerm = predictionData[impactTypeRefined][predictionSearchResult.entity].filter((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => predictionSearchResult.fieldIDList.includes(fieldIDData.field_id))
        // // temp, hard code: 先pass direct impact (TODO: refine后端prediction结果处理)
        // if (impactTypeRefined === ImpactType.DIRECT_IMPACT) {
        //   // temp, hard code: 先pass direct impact (TODO: refine后端prediction结果处理)
        // } else {
        //   predictionResult_SearchTerm = predictionData[predictionSearchResult.entity].filter((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => predictionSearchResult.fieldIDList.includes(fieldIDData.field_id))
        // }
      } else {
        console.log('==> GlyphGroup: predictionData[impactTypeRefined][predictionSearchResult.entity] is not found')
      }

    } else {
      // pass. Do nothing of historical flow
    }
  }

  // opt 2:
  // console.log('impactEntitySearchResult: ', impactEntitySearchResult)
  // note: 小钰现在搜索的是当前层的所有field_name。
  // TODO

  // console.log('predictionResult_SearchTerm: ', predictionResult_SearchTerm)
  // ////////////////////   Prediction Result  /////////////////////






  // 1. set global style parameters
  // 1-1. glyph size and r
  const glyphParameterDict = {
    glyphR: glyphStyle.glyphMaxR, // temp, unified glyph size. TODO: scale the group with total_impact
    minR_Ratio: glyphStyle.minR_Ratio,
    RDifference_Ratio: glyphStyle.RDifference_Ratio,  // value范围在[minR_Ratio, minR_Ratio + RDifference_Ratio]之间
  }
  const directImpact_RRange = [
    (glyphParameterDict.minR_Ratio.directImpact) * glyphParameterDict.glyphR,
    (glyphParameterDict.minR_Ratio.directImpact + glyphParameterDict.RDifference_Ratio.directImpact) * glyphParameterDict.glyphR
  ]
  const indirectImpact_RRange = [
    (glyphParameterDict.minR_Ratio.indirectImpact) * glyphParameterDict.glyphR,
    (glyphParameterDict.minR_Ratio.indirectImpact + glyphParameterDict.RDifference_Ratio.indirectImpact) * glyphParameterDict.glyphR
  ]

  // 2. set scale
  // 2-1. scale-1: node layout: XY position
  // opt 1: dimension reduction
  // const grantGlyphGroupR = glyphStyle.grantGlyphGroupR
  // const glyphPositionXYScale = {
  //   x:  d3.scaleLinear()
  //           .domain([Math.min(...ImpactCountGlyphData.map(d => d.tsne_x)), Math.max(...ImpactCountGlyphData.map(d => d.tsne_x))])
  //           .range([-(grantGlyphGroupR - glyphParameterDict.glyphR), (grantGlyphGroupR - glyphParameterDict.glyphR)]),
  //   y: d3.scaleLinear()
  //           .domain([Math.min(...ImpactCountGlyphData.map(d => d.tsne_y)), Math.max(...ImpactCountGlyphData.map(d => d.tsne_y))])
  //           .range([-(grantGlyphGroupR - glyphParameterDict.glyphR), (grantGlyphGroupR - glyphParameterDict.glyphR)])
  // }
  // opt 2: shixia's paper
  // TODO. 根据grant typology similarity等方法

  // 2-2.scale-2: glyph size scale
  const glyphSizeScaleAttr = 'funding_usd' // 'num_grant', 'funding_usd'
  const glyphRRangeRatio = glyphStyle.glyphRRangeRatio
  const glyph_SizeScale = d3.scaleSymlog() // scaleLinear, scaleSymlog
    .domain([Math.min(...glyphData.map(d => d[glyphSizeScaleAttr])), Math.max(...glyphData.map(d => d[glyphSizeScaleAttr]))])
    .range([glyphRRangeRatio.min, glyphRRangeRatio.max]);

  // for grant center node size
  const centerGrantNode_MaxMin = [Math.min(...glyphData.map(d => d['num_grant'])), Math.max(...glyphData.map(d => d['num_grant']))]
  // const numGrantGlyphR: number = glyphStyle.glyphMaxR * glyphStyle.minR_Ratio.directImpact * 0.7
  // const centerGrantNode_SizeScale = d3.scaleSymlog() // scaleLinear, scaleSymlog
  //   .domain([Math.min(...glyphData.map(d => d['num_grant'])), Math.max(...glyphData.map(d => d['num_grant']))])
  //   .range([0, numGrantGlyphR]);

  // 2-3. scale-3: axis in RCI glyph
  // // (1) calculate scale
  // const grantGlyphGroupR_RCIScale = d3.scaleLinear()
  //   .domain([Math.min(...RCIGlyphData.map(d => d.tsne_x)), Math.max(...RCIGlyphData.map(d => d.tsne_x))])
  //   .range([0, grantGlyphGroupR]);
  const attrList_RCIGlyph = {
    basicAttr: ['num_grant', 'funding_usd'],
    directImpact: ['RCI_num_paper', 'RCI_num_hit_paper', 'RCI_num_disruptive_paper', 'RCI_num_patent', 'RCI_num_clinical_trial'],
    indirectImpact: ['RCI_num_citing_patent', 'RCI_num_citing_clinical_trial', 'RCI_num_citing_policy', 'RCI_num_citing_newsfeed'],
  }
  // note: RCI glyph的scale是global的--所有axis共用一个scale；但impact count glyph的scale是local的--每个axis有自己的scale
  const getGlobalScale = (attributes: string[], RCIGlyphData: any, RRange: number[]) => {
    let allValues: any = d3.merge(RCIGlyphData.map((item: any) => attributes.map((attr: any) => item[attr])));
    let [globalMin, globalMax] = d3.extent(allValues);
    const scale = d3.scaleLinear()  // d3.scaleLinear()  scalePow()
        // @ts-ignore
        .domain([globalMin, globalMax])
        .range(RRange)
        // .exponent(2)
    return scale
  }
  const RCIGlyph_allAttributes = [...attrList_RCIGlyph.basicAttr, ...attrList_RCIGlyph.directImpact, ...attrList_RCIGlyph.indirectImpact]
  const RCIGlyphData = glyphData.map(item => {
    let newItem: any = {};
    RCIGlyph_allAttributes.forEach(attr => {
      if (item.hasOwnProperty(attr)) {
        newItem[attr] = item[attr];
      }
    });
    return newItem;
  })
  const scaleRDict_RCIGlyph = {
    basicAttr: '',
    directImpact: getGlobalScale(attrList_RCIGlyph.directImpact, RCIGlyphData, directImpact_RRange),
    indirectImpact: getGlobalScale(attrList_RCIGlyph.indirectImpact, RCIGlyphData, indirectImpact_RRange),
  }

  // 2-4. scale-4: axis in ImpactCount glyph
  const attrList_ImpactCountGlyph = {
    basicAttr: ['num_grant', 'funding_usd'],
    directImpact: ['num_paper', 'num_hit_paper', 'num_disruptive_paper', 'num_patent', 'num_clinical_trial'],
    indirectImpact: ['num_citing_patent', 'num_citing_clinical_trial', 'num_citing_policy', 'num_citing_newsfeed']
  }
  // calc scale (R direction)
  // use the same directImpact_RRange and indirectImpact_RRange as RCI glyph
  const getImpactCountScaleDict = (attributes: string[], ImpactCountGlyphData: any, RRange: number[]) => {
    return _.mapValues(_.keyBy(attributes), key => {
      const values = _.map(ImpactCountGlyphData, (d: any) => d[key])
      return d3.scaleLinear()
        .domain([_.min(values), _.max(values)])
        .range(RRange);
    });
  }
  const ImpactCountGlyph_allAttributes = [...attrList_ImpactCountGlyph.basicAttr, ...attrList_ImpactCountGlyph.directImpact, ...attrList_ImpactCountGlyph.indirectImpact]
  const ImpactCountGlyphData = glyphData.map(item => {
    let newItem: any = {};
    ImpactCountGlyph_allAttributes.forEach(attr => {
      if (item.hasOwnProperty(attr)) {
        newItem[attr] = item[attr];
      }
    });
    return newItem;
  })
  const scaleRDict_ImpactCountGlyph = {
    basicAttr: '',
    directImpact: getImpactCountScaleDict(attrList_ImpactCountGlyph.directImpact, ImpactCountGlyphData, directImpact_RRange),
    indirectImpact: getImpactCountScaleDict(attrList_ImpactCountGlyph.indirectImpact, ImpactCountGlyphData, indirectImpact_RRange),
  }


  // 3. draw glyph
  // 3-1. init node position using tsne x, y
  // temp: use impact count node position as initial position. 两种glyph mode用同一个初始化位置，这样切换glyph的时候，node位置、大小都不变，只改glyph -- keep context the same



  // 3-3. draw glyph list
  // // input
  // console.log('circleData: ', circleData)
  // console.log('predictionResult_SearchTerm: ', predictionResult_SearchTerm)

  // preprocess prediction result: add all value together (note: 一个grant可能加两次，但是暂时不解决了)
  const grantFieldPredictedSumList: any[] = []
  predictionResult_SearchTerm.forEach(fieldIDData => {
    const fieldID_GrantField_List = fieldIDData.df_GrantField_numGrant_topK_prediction

    fieldID_GrantField_List.forEach((grantFieldData: any) => {
      const grantFieldID = grantFieldData.grant_field_id
      const numGrant = grantFieldData.num_grant

      const existingGrantField = _.find(grantFieldPredictedSumList, { grant_field_id: grantFieldID });

      if (existingGrantField) {
        existingGrantField.num_grant += numGrant;
      } else {
        grantFieldPredictedSumList.push({
          grant_field_id: grantFieldID,
          num_grant: numGrant
        });
      }
    });
  })
  // console.log('==> after, grantFieldPredictedSumList: ', grantFieldPredictedSumList)


  // function for interactions
  const handleMouseLeave = (e: MouseEvent, id: string) => {
    const parts = id.split("-");
    const fieldID: string = parts[2];
    const impactEntity: string = parts[3];

    // hide wordle
    isShowWordle(false)
  }
  const handleMouseEnter = (e: MouseEvent, id: string) => {
    const parts = id.split("-");
    const fieldID: string = parts[2];
    const impactEntity: string = parts[3];
    // console.log('id: ', id)
    // console.log('grant node hover: ', fieldID, impactEntity)
    // console.log('\n\n')

    // show wordle
    isShowWordle(true)
    updateWordlePosition({
      left: e.clientX + 24,
      top: e.clientY + 24,
    })
    updateWordleEntity({
      // impact type (direct/indirect): 用state变量impactType即可
      entity: "grant",
      fieldID: fieldID,
    })
  }

  // const [clickedGrantFieldID, setClickedGrantFieldID] = useState<string>('all')
  let glyphElementList: JSX.Element[] = circleData.map((d, i) => {
    const fieldID: string = d.grant_field_code
    const fieldName: string = grantFieldCode2Name[fieldID]
    const scale = glyph_SizeScale(d[glyphSizeScaleAttr])

    let predictionData;
    predictionData = _.find(grantFieldPredictedSumList, { grant_field_id: fieldID })
    if (!predictionData) {
      predictionData = {}
    }

    let glyphElement: JSX.Element = <></>
    if (citationFlowType === CitationFlowType.PREDICTION) {
      glyphElement = <PredictionGlyph
                        key={`Prediction-${i}`}
                        id={i}
                        grantGroupName={d.grant_field_code}
                        // grantGroupName={fieldName}
                        // grant_field_name={d.grant_field_name}
                        glyphDataHistorical={d}
                        glyphDataPredicted={predictionData}
                        glyphStyle = {glyphStyle}
                        centerGrantNode_MaxMin = {centerGrantNode_MaxMin}
                      />
    } else { // CitationFlowType.HISTORICAL
      glyphElement = (glyphType === GrantGlyphType.RCIGLYPH) ? <RCIGlyph
                                                                  key={`RCI-${i}`}
                                                                  id={i}
                                                                  grantGroupName={d.grant_field_code}
                                                                  // grantGroupName={fieldName}
                                                                  // grant_field_name={d.grant_field_name}
                                                                  glyphDataHistorical={d}
                                                                  glyphDataPredicted={predictionData}
                                                                  attributeScale = {scaleRDict_RCIGlyph}
                                                                  attributeNameDict = {attrList_RCIGlyph}
                                                                  glyphParameterDict={glyphParameterDict}
                                                                  glyphStyle = {glyphStyle}
                                                                  centerGrantNode_MaxMin={centerGrantNode_MaxMin}
                                                                />
                                                                : <ImpactCountGlyph
                                                                  key={`ImpactCount-${i}`}
                                                                  id={i}
                                                                  grantGroupName={d.grant_field_code}
                                                                  // grantGroupName={fieldName}
                                                                  // grant_field_name={d.grant_field_name}
                                                                  glyphDataHistorical={d}
                                                                  glyphDataPredicted={predictionData}
                                                                  scaleRDict = {scaleRDict_ImpactCountGlyph}
                                                                  attributeNameDict = {attrList_ImpactCountGlyph}
                                                                  glyphStyle = {glyphStyle}
                                                                  centerGrantNode_MaxMin={centerGrantNode_MaxMin}
                                                                />
    }
    return (
      // <g transform={`translate(${grantGlyphGroupR_RCIScale(d.tsne_x)}, ${grantGlyphGroupR_RCIScale(d.tsne_y)}), scale(${scale})`}>
      <g key={`${i}-${d.grant_field_code}`} id={`leaf-node-${d.grant_field_code}-${impactType}`}
         className='grant-field-glyph'
         transform={`translate(${d.x}, ${d.y}), scale(${scale})`}

         opacity={ ((highlghtedGrantFieldID === 'all') || (highlghtedGrantFieldID === '') || (d.grant_field_code === highlghtedGrantFieldID)) ? 1: 0.15 }
         filter={ ((highlghtedGrantFieldID === 'all') || (highlghtedGrantFieldID === '') || (d.grant_field_code === highlghtedGrantFieldID)) ? "url(#shadow)": "none" }
        //  opacity={ ((clickedGrantFieldID === 'all') || (d.grant_field_code === clickedGrantFieldID)) ? 1: 0.15 }
        //  filter={ ((clickedGrantFieldID === 'all') || (d.grant_field_code === clickedGrantFieldID)) ? "url(#shadow)": "none" }

        onMouseEnter={(e) => {
          // console.log('hover!!!!!')
          const id = e.currentTarget.id
          handleMouseEnter(e as unknown as MouseEvent, id)
        }}
        onMouseLeave={(e) => {
          // console.log('leave!!!!!')
          const id = e.currentTarget.id
          handleMouseLeave(e as unknown as MouseEvent, id)
        }}
        onClick={() => {
          console.log('click node: ', d.grant_field_code)

          if (isShowPredictionGraph) {
            return
          } else if (isShowHistoricalGraph) {
            // unclick the node - 取消选择
            if(highlghtedGrantFieldID === d.grant_field_code) {
              // if (clickedGrantFieldID === d.grant_field_code) {
              // update ui reducer (to highlight links)
              onClickGrantFieldNode({
                grantFieldID: '',
                grantFieldName: '',
                impactType: impactType,
              })
              // clear highlighted impact field node
              onClickImpactFieldNode({
                impactType: '',
                impactEntity: '',
                impactFieldID: '',
              })

              // update css in leaf node
              isShowLeafNode(true)

              // show citation flow
              isShowHistoricalFlow(false)
              isShowPredictionFlow(false)

              // update useState (to change opacity of other nodes)
              updateHighlghtedGrantFieldID('all')
              // setClickedGrantFieldID('all')
              return
            } else {
              // update ui reducer (to highlight links)
              onClickGrantFieldNode({
                grantFieldID: d.grant_field_code,
                grantFieldName: d.grant_field_code,
                // grantFieldName: d.grant_field_name,
                impactType: impactType,
              })
              // clear highlighted impact field node
              onClickImpactFieldNode({
                impactType: '',
                impactEntity: '',
                impactFieldID: '',
              })

              // update css in leaf node
              isShowLeafNode(false)

              // show citation flow
              isShowHistoricalFlow(true)
              isShowPredictionFlow(false)

              // update useState (to change opacity of other nodes)
              // console.log('==> click grant group node: ', d.grant_field_code)
              updateHighlghtedGrantFieldID(d.grant_field_code)
              // setClickedGrantFieldID(d.grant_field_code)
            }
          } else {
            console.log('Error in GlyphGroup: invalid flow type! ')
          }
        }}
      >
        {/* <circle cx={0} cy={0} r={glyphParameterDict.glyphR} fill='white' opacity={1}></circle> */}
        {glyphElement}
        {/* { (glyphType === GrantGlyphType.RCIGLYPH) ? RCIGlyphElement : ImpactCountGlyphElement } */}
      </g>
    )
  })


  // console.log('=========== [Step 2.1] GrantTypeNode component (finished!) =============')


  return (
    <g id='grant-glyph-g' className='grant-glyph-g'>
      {glyphElementList}
    </g>
  )
}

export default GlyphGroup;